import React from 'react'
import Layout from '../../Components/Staff/Bill/Print/Layout'

function PrintBill() {
  return (
    <div>
      <Layout/>
    </div>
  )
}

export default PrintBill